import { render, staticRenderFns } from "./User.List.vue?vue&type=template&id=57204c25&"
import script from "./User.List.vue?vue&type=script&lang=js&"
export * from "./User.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports